import { SecurityPwdPopup } from "@/components/SecurityPwdPopup";
import SubLayout from "@/components/SubLayout";
import { Button } from "antd-mobile";
import { useState } from "react";
import styles from "./index.module.scss";
import { useUnBindSetup } from "./unbindLogic";
export function PageUnBindGoogleAuth() {
  const store = useUnBindSetup();
  const [modal, setModal] = useState<{
    visible: boolean;
    data: string;
  }>({
    visible: false,
    data: ""
  });
  const onSubmit = () => {
    setModal({
      visible: true,
      data: ""
    });
  };
  const onModalSubmit = (value: string) => {
    setModal({
      visible: false,
      data: ""
    });
    store.fetchUnBindGoogleAuthenticator({
      safeCode: value
    });
  };
  const onModalClose = () => {
    setModal({
      visible: false,
      data: ""
    });
  };
  return <SubLayout title={"解绑谷歌认证器"} footer={<Button className={"common-submit-button"} onClick={() => {
    onSubmit();
  }}>
          解绑
        </Button>} data-sentry-element="SubLayout" data-sentry-component="PageUnBindGoogleAuth" data-sentry-source-file="unbind.tsx">
      <section className={styles.tip}>
        {modal.visible ? "输入动态验证码以验证身份" : "请点击解绑按钮获取谷歌验证码"}
      </section>
      <SecurityPwdPopup visible={modal.visible} onSubmit={onModalSubmit} onClose={onModalClose} data-sentry-element="SecurityPwdPopup" data-sentry-source-file="unbind.tsx" />
    </SubLayout>;
}